import React from 'react';
import UserLayout from './UserLayout';
import BulkQuery from '../BulkQuery';

const UserBulkQuery = () => {
  return (
    <UserLayout>
      <BulkQuery />
    </UserLayout>
  );
};

export default UserBulkQuery;
